import { Dispatch, SetStateAction } from 'react';

import { Moment } from 'moment';

import { CheckAvailabilityViewModel, RoomViewModel } from '@api/v3';
import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';

import RoomSelectionCard from '../room-selection/RoomSelectionCard';
import { SelectedVariationProps } from '../../context/types';
import { getHandleSelectedVariationParams, getRoomCardProps } from './helpers';

interface Props {
  room: RoomViewModel;
  hotelId: number;
  startDate: Moment;
  endDate: Moment;
  hotelRoomList: ListingSearchRoomInterface[];
  nightCount: number;
  selectedTab: number;
  hotelName: string;
  isExpedia: boolean;
  openDatePicker: Dispatch<SetStateAction<boolean>>;
  selectedVariations: SelectedVariationProps[];
  handleSelectVariation: (variation: SelectedVariationProps) => void;
  availableDates?: CheckAvailabilityViewModel;
  isFetchingAvailableDates?: boolean;
  basketHotelCount?: number;
  country?: string;
}

const RoomOptionDetails = ({
  room,
  hotelId,
  isExpedia,
  hotelName,
  openDatePicker,
  nightCount,
  startDate,
  endDate,
  hotelRoomList,
  selectedTab,
  selectedVariations,
  handleSelectVariation,
  availableDates,
  basketHotelCount,
  country,
}: Props) => {
  return (
    <>
      {nightCount ? (
        room?.details?.map((detail) =>
          detail.informations
            ?.filter((inf) => inf.requestedRoomIndex === selectedTab)
            .map((information) =>
              information.variations.length ? (
                information.variations?.map((variation) => (
                  <RoomSelectionCard
                    key={variation?.id}
                    {...getRoomCardProps({
                      information,
                      detail,
                      selectedVariations,
                      variation,
                      hotelId,
                      hotelName,
                      hotelRoomList,
                      startDate,
                      endDate,
                      isExpedia,
                      selectedTab,
                    })}
                    roomId={room?.id}
                    dailyDiscountedPrice={variation}
                    openDatePicker={openDatePicker}
                    basketHotelCount={basketHotelCount}
                    onSelectVariation={() =>
                      variation.totalDiscountedSellingPrice
                        ? handleSelectVariation(
                            getHandleSelectedVariationParams({
                              information,
                              variation,
                              selectedTab,
                              detail,
                              roomId: room.id,
                              roomProvider: room.provider,
                              providerInfo: room?.providerInfo,
                              roomName: room.name,
                            })
                          )
                        : undefined
                    }
                    availableDates={availableDates}
                    country={country}
                  />
                ))
              ) : (
                <RoomSelectionCard
                  key={information?.requestedRoomIndex}
                  dailyDiscountedPrice={undefined}
                  title={detail.roomInfo?.boardType}
                  status={information.availabilityStatus}
                  alertMessage={information.availabilityMessage}
                  id={hotelId}
                  hotelName={hotelName}
                  formCheckInDate={startDate}
                  formCheckOutDate={endDate}
                  hotelRoomList={hotelRoomList}
                  openDatePicker={openDatePicker}
                  roomId={room?.id}
                  availableDates={availableDates}
                  basketHotelCount={basketHotelCount}
                  country={country}
                />
              )
            )
        )
      ) : (
        <RoomSelectionCard
          id={hotelId}
          warningText='Fiyatları görmek için tarih seçiniz'
          openDatePicker={openDatePicker}
          roomId={room?.id}
          availableDates={availableDates}
          basketHotelCount={basketHotelCount}
          country={country}
        />
      )}
    </>
  );
};

export default RoomOptionDetails;
